<template>
	<BuyBase
		:title="getConstants('PRICING_NEW_COMMON_PRO')"
		:actions="getConstants('PRICING_NEW_TAP_CHECK_DETAIL')"
		@viewDetail="viewDetail"
		type="pro"
		class="tap-pro"
	>
		<div slot="limit">
			<div class="banner">
				<img :src="bannerSrc" alt />
			</div>
			<div class="tp-op-price">
				<p class="save">
					<img src="../../images/sales.png" alt />
					{{ getConstants('PRICING_NEW_PAY_PRO_MAIN') }}
				</p>
			</div>
			<p>{{ space }}</p>
			<p>{{ add }}</p>

			<UploadTip />
			<UpgradeTip
				@close="upgradeShowed = true"
				v-if="upgradeVisible"
				class="upgrade-tip-pro"
			/>
		</div>
	</BuyBase>
</template>
<script>
import BuyBase from './BuyBase'
import banner from '../../../../assets/images/banner.svg'
import bannerEn from '../../../../assets/images/banner_en.svg'
import UploadTip from './UploadTip'
import UpgradeTip from '../UpgradeTip'

export default {
	props: {
		modalShow: {
			type: Boolean,
			required: false,
		},
		upgradeVersion: {
			type: [String, null],
		},
	},
	data() {
		return {
			banner,
			bannerEn,
			upgradeShowed: false,
		}
	},
	components: {
		BuyBase,
		UploadTip,
		UpgradeTip,
	},
	methods: {
		viewDetail() {
			this.upgradeShow = true
			this.$emit('viewDetail', 'pro')
		},
	},
	computed: {
		add() {
			let space = this.getConstants('PRICING_NEW_COMMON_ADD_SPACE') || ''
			return space.replace('%s', 1)
		},
		space() {
			let paid = this.getConstants('PRICING_NEW_COMMON_PAID_SPACE') || ''
			return paid + ' 30G'
		},
		bannerSrc() {
			return this.getConstants('LOCAL_LANGUAGE') === 'en' ? bannerEn : banner
		},
		upgradeVisible() {
			return (
				!this.modalShow && this.upgradeVersion === 'pro' && !this.upgradeShowed
			)
		},
	},
}
</script>
<style lang="scss" scoped>
.banner {
	position: absolute;
	right: -5px;
	top: -3px;
	> img {
		width: 104px;
		height: 104px;
	}
}
.tp-op-price {
	.save {
		font-size: 16px;
		padding-top: 12px;
		line-height: 30px;
		height: 30px;
		color: #ff5252;
		img {
			height: 30px;
			position: relative;
			top: 8px;
		}
	}
}
.tap-pro {
	width: 360px;
	height: 840px;
	margin-left: 28px;
	margin-right: 28px;
	box-shadow: 0 4px 24px 0 rgba(110, 110, 110, 0.05);
	&::before {
		background: #ffeeac;
	}
}

.upgrade-tip-pro {
	top: 330px;
}
</style>
